import React, { createContext, useContext, useState } from 'react';

const BlogContext = createContext(null);

export const BlogProvider = ({ children }) => {
  const [blogList, setBlogList] = useState(null);
  const [blogPosts, setBlogPosts] = useState({});

  const loadBlogList = async (file) => {
    const text = await file.json(); // читаем файл как текст
    setBlogList(text);
  };

  const saveBlogPost = (id, postText, language) => {
    blogPosts[id] = {
      ...blogPosts[id],
      [language]: postText
    };
    setBlogPosts(blogPosts);
  }

  return (
    <BlogContext.Provider value={{ blogList, loadBlogList, blogPosts, saveBlogPost }}>
      {children}
    </BlogContext.Provider>
  );
};

export const useBlogContext = () => useContext(BlogContext);
